import {faCheckSquare, faInfoCircle, faSyncAlt} from '@fortawesome/pro-solid-svg-icons';
import {Component, Input} from '@angular/core';
import {Spec} from "@webmate-web-core/shared/types/testmgmt";
import {TestService} from "@webmate-web-core/shared/services/test.service";
import {SpecId, SpecRef} from "@webmate-web-core/shared/types/ids";

@Component({
    selector: 'wm-spec-ref',
    templateUrl: './spec-ref.component.html',
    styleUrls: ['./spec-ref.component.less']
})
export class SpecRefComponent {
    constructor(private testService: TestService) {}

    @Input()
    specRef: SpecRef;

    @Input()
    showIcon: boolean = true;

    spec?: Spec;

    isError = false;

    ngOnChanges() {
        this.spec = undefined;
        this.isError = false;

        if (!this.specRef || this.specRef.type !== 'IdBasedSpecReference' || !this.specRef.specId) {
            this.isError = true;
            return;
        }

        this.loadSpec(this.specRef.specId);
    }

    loadSpec(specId: SpecId) {
        this.testService.getSpecs$([specId]).subscribe({
            next: (specs) => {
                if (specs?.length > 0) {
                    this.spec = specs?.[0];
                } else {
                    this.isError = true;
                }
            },
            error: (error) => {
                this.isError = true;
            }
        });
    }

    protected readonly faSyncAlt = faSyncAlt;
    protected readonly faInfoCircle = faInfoCircle;
    protected readonly faCheckSquare = faCheckSquare;
}
